import consumer from "./consumer"

consumer.subscriptions.create("MailerOpenerChannel", {
  received(data) {
    // This is the data we broadcasted from the backend.
    if (data.action === 'open_letter_opener') {
      const currentHost = window.location.origin;
      window.open(`${currentHost}/letter_opener`, '_blank');
    }
  }
});

